export default "__VITE_ASSET__B8dfh4F7__"